import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  overlayContainer: {
    margin: 0,
    padding: 0,
    backgroundColor: '#000000',
  },
});
